/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/partials/lined-list.module.scss';

const propTypes = {
    component: PropTypes.func,
    title: PropTypes.node,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            title: PropTypes.string,
        }),
    ),
    subitems: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            title: PropTypes.string,
        }),
    ),
    singleLine: PropTypes.bool,
    link: PropTypes.node,
    className: PropTypes.string,
};

const defaultProps = {
    component: null,
    title: null,
    items: [],
    subitems: [],
    singleLine: false,
    link: null,
    className: null,
};

const LinedList = ({ component, title, items, singleLine, link, className }) => {
    const sortedItems = useMemo(() => {
        const finalItems = [...items];
        finalItems.sort(({ main: aMain }, { main: bMain }) => {
            if (aMain === bMain) {
                return 0;
            }
            return aMain && !bMain ? -1 : 1;
        });
        return finalItems;
    }, [items]);

    const twoLines = singleLine && link === null && sortedItems.length > 2;
    const finalItems = twoLines ? sortedItems.filter((it, i) => i === 0) : sortedItems;
    const subItems = twoLines ? sortedItems.filter((it, i) => i !== 0) : [];

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.singleLine]: singleLine,
                    [className]: className !== null,
                },
            ])}
        >
            {title !== null ? <h4 className={styles.title}>{title}</h4> : null}
            <ul className={styles.items}>
                {finalItems.map((item, index) => {
                    const Component = component || null;
                    const { name } = item || {};
                    return Component !== null ? (
                        <Component
                            key={`item-${index + 1}`}
                            className={styles.component}
                            {...item}
                        />
                    ) : (
                        <li
                            key={`item-${index + 1}`}
                            className={classNames([
                                styles.item,
                                { [styles.main]: singleLine && index === 0 },
                            ])}
                        >
                            <strong className={styles.name}>{name}</strong>
                        </li>
                    );
                })}
                {link !== null ? <li className={styles.link}>{link}</li> : null}
            </ul>
            {subItems.length > 0 ? (
                <ul className={styles.items}>
                    {subItems.map((item, index) => {
                        const Component = component || null;
                        const { name } = item || {};
                        return Component !== null ? (
                            <Component
                                key={`subitem-${index + 1}`}
                                className={styles.component}
                                {...item}
                            />
                        ) : (
                            <li key={`subitem-${index + 1}`} className={classNames([styles.item])}>
                                <strong className={styles.name}>{name}</strong>
                            </li>
                        );
                    })}
                </ul>
            ) : null}
        </div>
    );
};

LinedList.propTypes = propTypes;
LinedList.defaultProps = defaultProps;

export default LinedList;
